<div class="row mb-1">
  @if (content().addressTitle; as addressTitle) {
    <div class="col-12">
      <p class="h6 mb-0 fw-bold">{{ addressTitle }}</p>
    </div>
  }
</div>

@if (content().useAccessibleCalculator) {
  <div class="row">
    <!-- Form errors -->
    <div class="col-12">
      @if (postalCodeInvalid() && houseNumberInvalid()) {
        <crnt-form-control-validation-message
          slot="validation"
          wlAutomationId="postalcode-housenumber-required-error"
          id="postalcode-housenumber-required-error"
        >
          Een geldige postcode en huisnummer zijn vereist
        </crnt-form-control-validation-message>
      } @else {
        @if (postalCodeInvalid()) {
          <crnt-form-control-validation-message
            slot="validation"
            wlAutomationId="postalcode-invalid-error"
            id="postalcode-invalid-error"
            >Controleer je postcode
          </crnt-form-control-validation-message>
        }
        @if (houseNumberInvalid()) {
          @if (controls().houseNumber?.errors?.['required']) {
            <crnt-form-control-validation-message
              slot="validation"
              wlAutomationId="housenumber-required-error"
              >Vul je huisnummer in</crnt-form-control-validation-message
            >
          } @else {
            <crnt-form-control-validation-message
              slot="validation"
              wlAutomationId="housenumber-invalid-error"
              >Controleer je huisnummer</crnt-form-control-validation-message
            >
          }
        }
      }
    </div>

    <!-- Postal Code -->
    <div class="col-6 col-lg-4">
      <crnt-form-control>
        <crnt-text-input [state]="postalCodeInvalid() ? 'invalid' : 'enabled'">
          <input
            type="text"
            [id]="controls().postalCode.id"
            [ngrxFormControlState]="controls().postalCode"
            [ngrxValueConverter]="uppercaseConverter"
            aria-describedby="postalcode-housenumber-required-error postalcode-invalid-error"
            autocomplete="postal-code"
          />
        </crnt-text-input>
        <crnt-form-control-label slot="label">
          <label [for]="controls().postalCode.id" class="fw-normal">
            {{ content().postalCodeLabel }}
          </label>
        </crnt-form-control-label>
      </crnt-form-control>
    </div>

    <!-- House Number -->
    <div class="col-6 col-lg-4">
      <crnt-form-control>
        <crnt-text-input [state]="houseNumberInvalid() ? 'invalid' : 'enabled'">
          <input
            type="text"
            [id]="controls().houseNumber?.id"
            [ngrxFormControlState]="controls().houseNumber"
            aria-describedby="postalcode-housenumber-required-error housenumber-invalid-error"
          />
        </crnt-text-input>
        <crnt-form-control-label slot="label">
          <label [for]="controls().houseNumber?.id" class="fw-normal">
            {{ content().houseNumberLabel }}
          </label>
        </crnt-form-control-label>
      </crnt-form-control>
    </div>

    <!-- House Number Addition -->
    <div class="col-6 col-lg-4">
      <crnt-form-control>
        <crnt-select
          [aria-disabled]="controls().houseNumberAddition.isDisabled"
          [class]="
            controls().houseNumberAddition.isDisabled ? 'disabled-element' : ''
          "
        >
          <select
            [wlTrackValueChange]="{
              step: 0,
              rendering: rendering(),
              label: 'toevoeging',
              inputLabel: controls().houseNumberAddition.value || '',
              sendValue: true,
              trackFocus: true,
              stepName: 'invullen',
            }"
            [id]="controls().houseNumberAdditionAltSelection.id"
            wlAutomationId="calculate-house-number-addition-dropdown"
            [ngrxFormControlState]="controls().houseNumberAdditionAltSelection"
            [disabled]="controls().houseNumberAddition.isDisabled"
            [class]="
              controls().houseNumberAddition.isDisabled
                ? 'disabled-element'
                : ''
            "
            [aria-live]="
              controls().houseNumberAddition.isDisabled ? '' : 'polite'
            "
          >
            @if (controls().houseNumberAddition.isEnabled && !showLoader()) {
              @for (
                houseNumberAdditionOption of houseNumberAdditions();
                track houseNumberAdditionOption.value
              ) {
                <option [value]="houseNumberAdditionOption.value">
                  {{ houseNumberAdditionOption.label }}
                </option>
              }
            }
          </select>
          @if (showLoader()) {
            <crnt-icon
              icon="spinner-third"
              animation="spin"
              aria-label="loading"
            >
            </crnt-icon>
          }
        </crnt-select>
        <crnt-form-control-label slot="label">
          <label
            [for]="controls().houseNumberAdditionAltSelection.id"
            class="fw-normal"
          >
            {{ content().houseNumberAdditionLabel }}
          </label>
        </crnt-form-control-label>
      </crnt-form-control>
    </div>

    @if (
      controls().houseNumberAddition.isEnabled &&
      enableCrntHouseNumberAddition() &&
      !showLoader()
    ) {
      <div class="col-12 mt-2">
        <div class="house-number-addition-info-card">
          @if (manualHouseNumberAdditionInput()) {
            <p>
              Helaas, wij hebben geen bestaand adres gevonden. Klopt het wel,
              dan kun je verder.
            </p>
            <crnt-form-control>
              <crnt-text-input>
                <input
                  type="text"
                  [id]="controls().houseNumberAddition.id"
                  [ngrxFormControlState]="controls().houseNumberAddition"
                  wlAutomationId="calculate-house-number-addition-input"
                />
              </crnt-text-input>
              <crnt-form-control-label slot="label">
                <label [for]="controls().houseNumberAddition.id">
                  Wat is je toevoeging?
                </label>
              </crnt-form-control-label>
            </crnt-form-control>
            @if (!!controls().houseNumberAddition.value?.length) {
              <div><span class="fw-bold">Dit is je adres</span></div>
              {{ showProvidedInstallationAddress() }}
            }
          } @else {
            <span aria-live="polite">
              {{ showProvidedInstallationAddress() }}</span
            >
          }
        </div>
      </div>
    }

    @if (showLoader()) {
      <div class="col-12 mt-2 house-number-addition-info-card">
        <div class="mx-auto">
          <crnt-icon
            icon="spinner-third"
            animation="spin"
            aria-label="loading"
          ></crnt-icon>
        </div>
      </div>
    }
  </div>
} @else {
  @if (!isAlternateAddressEntryEnabled() || !isAddressManualTriggerActive()) {
    <div
      class="row g-1"
      [ngClass]="isAlternateAddressEntryEnabled() ? 'mb-3' : ''"
    >
      <!-- PostalCode -->
      <div class="col-12 col-md-4">
        <wl-text
          wlAutocomplete="postal-code"
          [rendering]="rendering()"
          [step]="0"
          stepName="invullen"
          fieldName="postcode"
          [sendValue]="false"
          [valueConverter]="uppercaseConverter"
          [formsControl]="controls().postalCode"
          [placeholder]="content().postalCodePlaceholder ?? ''"
          [label]="content().postalCodeLabel ?? ''"
        ></wl-text>
      </div>
      <!-- HouseNumber -->
      <div class="col-6 col-md-4">
        <wl-number
          wlAutocomplete="housenumber"
          [rendering]="rendering()"
          [step]="0"
          stepName="invullen"
          fieldName="huisnummer"
          [sendValue]="false"
          [formsControl]="controls().houseNumber"
          [placeholder]="content().houseNumberPlaceholder ?? ''"
          [label]="content().houseNumberLabel ?? ''"
        ></wl-number>
      </div>
      <!-- HouseNumberAddition -->
      @if (!controls().houseNumberAddition.isDisabled) {
        <div class="col-6 col-md-4">
          @if (!manualHouseNumberAdditionInput()) {
            <wl-dropdown
              [wlTrackValueChange]="{
                step: 0,
                rendering: rendering(),
                label: 'toevoeging',
                inputLabel: controls().houseNumberAddition.value || '',
                sendValue: true,
                trackFocus: true,
                stepName: 'invullen',
              }"
              [dropdownItems]="houseNumberAdditions()"
              [formsControl]="controls().houseNumberAddition"
              [label]="content().houseNumberAdditionLabel ?? ''"
              wlAutomationId="calculate-house-number-addition-dropdown"
            ></wl-dropdown>
          } @else {
            <div class="flex-nowrap position-relative">
              <wl-text
                [rendering]="rendering()"
                stepName="invullen"
                [step]="0"
                fieldName="toevoeging"
                placeholder="Toevoeging"
                [formsControl]="controls().houseNumberAddition"
                [label]="content().houseNumberAdditionLabel ?? ''"
                wlAutomationId="calculate-house-number-addition-input"
              ></wl-text>
              @if (!content().useSupervisedManualHouseNumberAddition) {
                <button
                  class="btn-close inline-input-button my-auto"
                  (click)="hideManualHouseNumberAdditionInput.emit()"
                ></button>
              }
            </div>
          }
        </div>
      }
      @if (showLoader()) {
        <div class="col-6 col-md-4">
          <wl-loading></wl-loading>
        </div>
      }

      <!-- TODO: revisit this, formState is always inValid at this point because the rest of the form (Calculate) has not been filled in yet (SOS-6585)-->
      @if (formState() | isInvalid) {
        <div class="col-12 mt-0">
          <!-- Error messages -->
          @if (controls().postalCode | isInvalid) {
            @if (controls().postalCode.errors['required']) {
              <wl-input-error
                wlAutomationId="postalcode-required-error"
                [messageField]="content().postalCodeRequiredError ?? ''"
                messageDescription="postcode"
                [rendering]="rendering()"
                stepName="invullen"
              ></wl-input-error>
            }
            @if (controls().postalCode.errors.isPostalCode) {
              <wl-input-error
                wlAutomationId="postalcode-invalid-error"
                [messageField]="content().postalCodeNotValidError ?? ''"
                messageDescription="postcode"
                [rendering]="rendering()"
                stepName="invullen"
              ></wl-input-error>
            }
          }
          @if (controls().houseNumber | isInvalid) {
            @if (controls().houseNumber?.errors?.['required']) {
              <wl-input-error
                wlAutomationId="housenumber-required-error"
                [messageField]="content().houseNumberRequiredError"
                messageDescription="huisnummer"
                [rendering]="rendering()"
                stepName="invullen"
              ></wl-input-error>
            } @else {
              <wl-input-error
                wlAutomationId="housenumber-invalid-error"
                [messageField]="content().houseNumberNotValidError"
                messageDescription="huisnummer"
                [rendering]="rendering()"
                stepName="invullen"
              ></wl-input-error>
            }
          }
        </div>
      }

      @if (!content().useSupervisedManualHouseNumberAddition) {
        @if (showAddressNotFoundMessage()) {
          <div class="col-12 mt-2">
            <wl-info-card
              wlAutomationId="calculate-installation-address-not-found"
              [title]="{ value: content().addressNotFoundErrorTitle }"
              [message]="{ value: content().addressNotFoundErrorMessage }"
              [border]="true"
              [shadow]="false"
            ></wl-info-card>
          </div>
        }
      } @else {
        @if (showAddressNotFoundMessage()) {
          <div class="col-12 mt-2 house-number-addition-info-card">
            <p>{{ content().addressNotFoundErrorMessage }}</p>
          </div>
        } @else if (controls().houseNumberAdditionAltSelection.isEnabled) {
          <div class="col-12 mt-2 house-number-addition-info-card">
            <p class="mb-1">{{ content().addressNotFoundErrorMessage }}</p>
            <div>
              <p>{{ content().houseNumberAdditionSelectLabel }}</p>
              <wl-dropdown
                [wlTrackValueChange]="{
                  step: 0,
                  rendering: rendering(),
                  label: 'toevoeging',
                  inputLabel: controls().houseNumberAddition.value || '',
                  sendValue: true,
                  trackFocus: true,
                  stepName: 'invullen',
                }"
                [dropdownItems]="houseNumberAdditions()"
                [formsControl]="controls().houseNumberAdditionAltSelection"
                [label]="content().houseNumberAdditionLabel ?? ''"
                wlAutomationId="calculate-house-number-addition-dropdown"
              ></wl-dropdown>
            </div>
          </div>
        }
      }
    </div>
  }

  @if (isAlternateAddressEntryEnabled()) {
    @if (!isAddressManualTriggerActive()) {
      <div class="row mt-1">
        <div class="col-12">
          <button
            (click)="setAddressNextButtonClicked.emit()"
            wlTrackLink
            [trackLinkInfo]="{
              eventType: 'button-click',
              rendering: rendering(),
              field: 'Bereken maandbedrag',
            }"
            class="btn btn-sales-primary w-100"
            wlAutomationId="calculate-address-submit-button"
            [disabled]="showLoader()"
          >
            <span>{{ content().addressManualInputButtonLabel }}</span>
            @if (showLoader()) {
              <crnt-icon class="ms-2" icon="spinner-third" animation="spin" />
            }
          </button>
        </div>
      </div>
    } @else {
      <div class="row mt-1">
        <div class="col-12">
          <p class="mb-0">
            <span class="pe-1">{{
              !showLoader() && showProvidedInstallationAddress()
            }}</span>
            <button
              class="btn btn-link p-0"
              (click)="updateAddressButtonClicked.emit()"
            >
              {{ content().updateAddressLabel }}
            </button>
          </p>
        </div>
      </div>
    }
  }
}
